/**
 * Mobile menu toggle for the site header.
 *
 * Looks for [data-menu-toggle] and the nav with [data-menu]. Flips aria-expanded
 * and a data attribute on the nav for CSS to consume. No CSS lives here.
 */
export default function initMenuToggle() {
	const toggle = document.querySelector( '[data-menu-toggle]' );
	const menu = document.querySelector( '[data-menu]' );
	if ( ! toggle || ! menu ) return;
	const compactBreakpoint = menu.classList.contains( 'site-nav__links' ) ? 760 : 1023;
	const isCompact = () => window.matchMedia( `(max-width: ${ compactBreakpoint }px)` ).matches;

	const setOpen = ( open ) => {
		const active = open && isCompact();
		toggle.setAttribute( 'aria-expanded', active ? 'true' : 'false' );
		menu.dataset.open = open ? 'true' : 'false';
		menu.setAttribute( 'aria-hidden', isCompact() && ! active ? 'true' : 'false' );
		document.documentElement.classList.toggle( 'menu-open', active );
	};

	setOpen( false );

	toggle.addEventListener( 'click', () => {
		const isOpen = toggle.getAttribute( 'aria-expanded' ) === 'true';
		setOpen( ! isOpen );
	} );

	// Close on Escape.
	document.addEventListener( 'keydown', ( e ) => {
		if ( e.key === 'Escape' && toggle.getAttribute( 'aria-expanded' ) === 'true' ) {
			setOpen( false );
			toggle.focus();
		}
	} );

	// Anchor navigation should leave the next section unobscured by the mobile panel.
	menu.querySelectorAll( 'a' ).forEach( ( link ) => {
		link.addEventListener( 'click', () => setOpen( false ) );
	} );

	window.addEventListener( 'resize', () => setOpen( false ) );
}
